import { sendEmail } from "@stepapp/core";
import type { PropsWithChildren } from "react";
import { IntercomProvider as IntercomProviderWeb, useIntercom } from "react-use-intercom";

export const logoutIntercom = () => {};
export const handleIntercomPushMessage = () => {};

declare global {
  interface Window {
    dataLayer: ToDo | undefined;
    [key: string]: ToDo;
  }
}

const callIntercomMethod = (method: string, ...args: ToDo[]) => {
  window.Intercom?.apply(null, [method, ...args]);
};

const handleIntercomShutdown = (shutdown: () => ToDo) => {
  /**
   * A little web hack but works correctly.
   * We don't need intercom button so as soon as messenger is closed
   * we remove Intercom from webpage.
   */
  setTimeout(() => {
    try {
      shutdown();
      callIntercomMethod("shutdown");
    } catch (_error) {}
  }, 500);
};

let userEmail = "";

export const setIntercomUser = (email: string) => {
  userEmail = email;
};

export const useDisplayIntercom = (countryCode: string) => {
  const { boot, show, shutdown } = useIntercom();

  return () => {
    if (countryCode === "NO") {
      return sendEmail("info@stepapp.no", "[Help Chat]: ");
    }

    const user = userEmail || Math.random().toString().slice(2, 16);
    const settings = {
      app_id: "q0ebcoua",
      email: user,
      user_id: user,
      name: user,
      user,
    };
    boot({ name: user, email: user, userId: user });
    window.intercomSettings = settings;
    callIntercomMethod("boot", settings);
    callIntercomMethod("onHide", () => handleIntercomShutdown(shutdown));
    return show();
  };
};

export const IntercomProvider = ({ children }: PropsWithChildren) => {
  return (
    <IntercomProviderWeb appId="q0ebcoua" autoBoot={false}>
      {children}
    </IntercomProviderWeb>
  );
};
